const App = ({ children }) => {
  return children;
};

export default App;
